<template lang="pug">
    .modal.final-video
        .modal-background(
            @click="$emit('close')"
        )
        .modal-card
            section.modal-card-body.map-final-video
                video.final.video(
                    controls
                    controlslist="nodownload"
                    src="videos/finalVideo.mp4"
                    type="video/mp4"
                    disablePictureInPicture
                    autoplay
                )
        a.button.delete(
            @click.prevent="$emit('close')"
            :title="$i18n.t('map.map_conversation_close')"
        )
</template>

<script>

import {mapState} from "vuex";
import UserApi from "../../../../api/user/user";
import CITIES from '../../../../config/cities.json'


export default {
    mounted() {
        const video = document.querySelector(".video");

        video.addEventListener("ended", () => {
           this.$emit('close');
        });
    },
    beforeDestroy() {
        if (this.user.mapLocation.name === CITIES[CITIES.length - 1]) {
            this.updateCity();
        }
    },
    methods: {
        updateCity() {
            UserApi.updateCity(this.user.id)
                .then(() => {
                    this.$store.dispatch('setUserByToken');
                })
                .catch(error => {
                    this.$toasted.error(this.$root.$t(`errors.${error.data.message}`));
                })
        },
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        })
    }
}

</script>

<style lang="scss" scoped>
.final-video {

  .modal-card {
    max-width: 1500px;
    max-height: calc(100% - 20px);
    margin: 20px;
    background-color: grey;
  }

  .modal-card-body {
    position: relative;
    display: flex;
    align-items: center;
  }

  .video {
    width: 100%;
  }

  .button {
    &.delete {
      height: 40px;
      width: 40px;
      user-select: none;
      appearance: none;
      background-color: rgba(10, 10, 10, 0.2);
      border: none;
      border-radius: 290486px;
      cursor: pointer;
      display: inline-block;
      font-size: 1rem;
      outline: none;
      position: absolute;
      top: 10px;
      right: 10px;
    }

    &.delete:before, &.delete:after {
      background-color: white;
      content: "";
      display: block;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%) rotate(45deg);
      transform-origin: center center;
    }

    &.delete:before {
      height: 2px;
      width: 50%;
    }

    &.delete:after {
      height: 50%;
      width: 2px;
    }

    &.delete:hover, &.delete:focus {
      background-color: rgba(10, 10, 10, 0.3);
    }

    &.delete:active {
      background-color: rgba(10, 10, 10, 0.4);
    }
  }
}
</style>
